/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Processing_TitleInputs */

const vi_tea_purchase_processing_title = /** @type {(inputs: Tea_Purchase_Processing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sản xuất chè`)
};

/**

* @param {Tea_Purchase_Processing_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_processing_title = /** @type {((inputs?: Tea_Purchase_Processing_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Processing_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_processing_title(inputs)
});